import { useEffect, useState } from "react";

/**
 * `true` kalau lebar layar ≥ 1024px (breakpoint `lg` Tailwind).
 *
 * Dipindah apa adanya dari Layout.jsx supaya TIGA layout (Layout, FinanceLayout,
 * MarketingLayout) memakai satu sumber saat memilih di mana <NotificationBell>
 * dipasang. Tiap lonceng yang ter-mount memanggil GET /notifications/count sendiri,
 * dan CSS `lg:hidden` hanya menyembunyikan, tidak meng-unmount — jadi pilihan
 * "instance mana yang dipasang" harus memakai breakpoint yang SAMA persis dengan
 * sidebar/topbar. Kalau tiap layout menyalin angka ini sendiri, cepat atau lambat
 * satu layout memasang dua lonceng atau nol lonceng.
 */
export function useApakahDesktop() {
  const [isDesktop, setIsDesktop] = useState(
    () => typeof window !== "undefined" ? window.matchMedia("(min-width: 1024px)").matches : true
  );
  useEffect(() => {
    const mq = window.matchMedia("(min-width: 1024px)");
    const onChange = (e) => setIsDesktop(e.matches);
    mq.addEventListener("change", onChange);
    return () => mq.removeEventListener("change", onChange);
  }, []);
  return isDesktop;
}
